import React, { useState } from 'react';

const EmployesModule = () => {
  const [employes] = useState([
    { id: 1, prenom: "Karmelle", nom: "HAZOUMÈ", poste: "Assistante Technique Projets", dept: "Direction Générale", av: "KH", color: "#C9A84C", contrat: "CDI", present: true, score: 9.1 },
    { id: 2, prenom: "Marie", nom: "BIOKOU", poste: "Comptable", dept: "Comptabilité", av: "MB", color: "#66bb6a", contrat: "CDI", present: true, score: 8.7 },
    { id: 3, prenom: "Kofi", nom: "PANOU", poste: "Aide-Comptable", dept: "Comptabilité", av: "KP", color: "#42a5f5", contrat: "CDD", present: true, score: 7.2 },
    { id: 4, prenom: "Jean-Paul", nom: "ADÉWOLÉ", poste: "Développeur Web", dept: "FHC Technologie", av: "JA", color: "#ef5350", contrat: "CDI", present: false, score: 6.8 },
  ]);

  return (
    <div style={{ padding: '20px 24px', background: '#0a1628', minHeight: '100vh' }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 24, fontWeight: 600, color: '#fff', marginBottom: 4 }}>
          👥 Mon Équipe — Comptabilité & Finance
        </h1>
        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.42)' }}>
          {employes.length} collaborateur(s) · Département Comptabilité
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#152236', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#42a5f5' }} />
          <div style={{ fontSize: 18, marginBottom: 6 }}>👥</div>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600 }}>{employes.length}</div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Collaborateurs</div>
        </div>
        <div style={{ background: '#152236', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#4caf50' }} />
          <div style={{ fontSize: 18, marginBottom: 6 }}>✅</div>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, color: '#4caf50' }}>
            {employes.filter(e => e.present).length}
          </div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Présents</div>
        </div>
        <div style={{ background: '#152236', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#ef5350' }} />
          <div style={{ fontSize: 18, marginBottom: 6 }}>❌</div>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, color: '#ef5350' }}>
            {employes.filter(e => !e.present).length}
          </div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Absents</div>
        </div>
        <div style={{ background: '#152236', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#C9A84C' }} />
          <div style={{ fontSize: 18, marginBottom: 6 }}>⭐</div>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, color: '#C9A84C' }}>
            {(employes.reduce((s, e) => s + e.score, 0) / employes.length).toFixed(1)}
          </div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.42)' }}>Score moyen</div>
        </div>
      </div>

      <div style={{ background: '#152236', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: 'rgba(255,255,255,0.02)' }}>
              <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Collaborateur</th>
              <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Poste</th>
              <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Contrat</th>
              <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Présence</th>
              <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Score</th>
            </tr>
          </thead>
          <tbody>
            {employes.map(e => (
              <tr key={e.id} style={{ cursor: 'pointer', transition: 'background 0.15s' }}>
                <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: e.color + '22', color: e.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>
                      {e.av}
                    </div>
                    <div>
                      <div style={{ color: '#fff', fontWeight: 500 }}>{e.prenom} {e.nom}</div>
                      <div style={{ fontSize: 9, color: '#556' }}>Depuis Juin 2023</div>
                    </div>
                  </div>
                </td>
                <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>{e.poste}</td>
                <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  <span style={{
                    fontSize: 9,
                    fontWeight: 600,
                    padding: '2px 8px',
                    borderRadius: 99,
                    background: e.contrat === 'CDI' ? 'rgba(67,160,71,0.15)' : 'rgba(30,136,229,0.15)',
                    color: e.contrat === 'CDI' ? '#66bb6a' : '#64b5f6'
                  }}>
                    {e.contrat}
                  </span>
                </td>
                <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  {e.present ? (
                    <span style={{
                      fontSize: 9,
                      fontWeight: 600,
                      padding: '2px 8px',
                      borderRadius: 99,
                      background: 'rgba(67,160,71,0.15)',
                      color: '#66bb6a'
                    }}>
                      ● Présent
                    </span>
                  ) : (
                    <span style={{
                      fontSize: 9,
                      fontWeight: 600,
                      padding: '2px 8px',
                      borderRadius: 99,
                      background: 'rgba(229,57,53,0.15)',
                      color: '#ef8080'
                    }}>
                      ● Absent
                    </span>
                  )}
                </td>
                <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  <span style={{
                    fontFamily: 'Cormorant Garamond, serif',
                    fontSize: 18,
                    fontWeight: 600,
                    color: e.score >= 8 ? '#66bb6a' : e.score >= 6 ? '#C9A84C' : '#ef8080'
                  }}>
                    {e.score}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployesModule;
